<template>
  <div class="cstm-tab-holder w-full">
    <!-- <pre>{{settings_obj}}</pre> -->
    <!-- <pre>{{settings_obj}}</pre> -->
    <vs-tabs class="course_vs_tabs cstm_line_tabular_view">
      <!-- course type -->
      <vs-tab label="Course Type">
        <div class="tab-text">
          <!-- <div class="blue-holder">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.
          </div> -->
          <table class="course-table course_type_table w-full p-4 border-top">
            <tr>
              <td>
                <vs-radio
                  vs-name="course_type"
                  v-model="settings_obj.course_type"
                  vs-value="1"
                  ><b>Open</b></vs-radio
                >
              </td>
              <td>
               
                  <strong class="mb-2" style="color: rgba(var(--vs-primary), 1);">Open courses are based on the following rules:</strong>
                
                <ul class="course_settings_listing">
                  <li>Free & open to anyone visiting your site</li>
                  <li>
                    No registration, login or payment is required for access
                  </li>
                  <li>Must be registered/logged in to track course progress</li>
               
                <li>
                  If you have Open courses on your site, as soon as someone
                  registers an account, they will automatically gain access to
                  all Open courses.
                </li>
                 </ul>
              </td>
            </tr>
            <tr>
              <td>
                <vs-radio
                  vs-name="course_type"
                  v-model="settings_obj.course_type"
                  vs-value="2"
                  ><b>Free</b></vs-radio
                >
              </td>
              <td>
                <strong class="mb-2" style="color: rgba(var(--vs-primary), 1);">Free courses are based on the following rules:</strong>
                 <ul class="course_settings_listing">
                <li>Must be registered/logged in to access</li>
                <li>No payment is required</li>

               <li> “Take this Course” button is shown to users not yet enrolled.
                  They are sent through the registration process. If you’re
                  using Scoolio’s customized login & registration, the button
                  will say “Login to Enroll.”</li>
                <li>
                  The Free access mode is a good choice if you want an
                  administrator to manually enrol students into the course.
                </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <vs-radio
                  vs-name="course_type"
                  v-model="settings_obj.course_type"
                  vs-value="3"
                  ><b>Paid</b></vs-radio
                >
              </td>
              <td>
               <strong class="mb-2" style="color: rgba(var(--vs-primary), 1);">  Paid courses are based on the following rules:</strong>
 <ul class="course_settings_listing">
<li>Must be registered/logged in to access</li>

<li>Requires a one-time fee to be paid (no free access)</li>

<li>Only works with the following payment methods: PayPal, Stripe & GoCardless</li>
 <li> When using the Paid mode, you need to enter a price in the Course Price field.
First, select the Paid access mode.
Then, enter your price in the Course Price field</li>
</ul>
<small>NOTE: </small>
<span class="mb-2">
For Paid access modes, the student will be automatically enrolled into the course upon a completed payment.</span>
              
              </td>
            </tr>
            <tr>
              <td>
                <vs-radio
                  vs-name="course_type"
                  v-model="settings_obj.course_type"
                  vs-value="4"
                  ><b>Recurring</b></vs-radio
                >
              </td>
              <td>
               
<strong class="mb-2" style="color: rgba(var(--vs-primary), 1);">Recurring is very similar to Paid,except for recurring payment (as opposed to one-time payments). </strong>
<strong class="mb-2" style="color: rgba(var(--vs-primary), 1);">Recurring courses are based on the following rules:</strong>
 <ul class="course_settings_listing">
<li>Must be registered/logged in to access</li>

<li>Requires a recurring fee (choose a billing cycle in X days, weeks, months or years)</li>

<li>Only works with the following payment methods: PayPal, Stripe & GoCardless</li>
 </ul>
              </td>
            </tr>

            
          </table>
        </div>
      </vs-tab>

      <!-- financial settings -->
      <vs-tab label="Financial">
        <div class="tab-text">
          <!--  -->
          <table class="course-table w-full p-4 border-top">
            <tr>
              <td>
                <h5 class="mb-2">Currency</h5>
              </td>
              <td>
                  <v-select
              append-to-body
                class="w-full"
                placeholder="Currency List"
                label="currency_name"
                :options="currencyLists"
                name="currency_name"
                v-validate="'required'"
                :reduce="(item) => item.id"
                 v-model="currency_id"
                :disabled="true"
              >
                  </v-select>
              </td>
            </tr>
            <tr>
              <td>
                <h5 class="mb-2">Payment Plan</h5>
                <strong class="mb-2" style="color: rgba(var(--vs-primary), 1);">The Payment Plan allows for a couple of options:</strong>
                <ul class="course_settings_listing">
                  <li>One Time Payment: the entire cost of the course is paid upfront before accessing the course.</li>
                  <li>Installment Plan: provides an option to pay for the course in regular (daily, weekly, monthly, yearly) payment installements.</li>
                </ul>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="payment_option"
                    v-model="settings_obj.payment_option"
                    vs-value="1"
                    >One Time Payment</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="payment_option"
                    v-model="settings_obj.payment_option"
                    vs-value="2"
                    >Installment Plan</vs-radio
                  >
                </div>
                <!-- <div class="my-2">
                  <vs-radio
                    vs-name="payment_option"
                    v-model="settings_obj.payment_option"
                    vs-value="3"
                    >Both</vs-radio
                  >
                </div> -->
              </td>
            </tr>
            <tr v-if="settings_obj.payment_option === '2'">
              <td>
                <h5 class="mb-2">
                  Number of Installments <span class="text-red"></span>
                </h5>
              </td>
              <td>
                <v-select
                  class="w-full"
                  v-model="settings_obj.installment_no_id"
                  :options="installments"
                  :reduce="(option) => option.id"
                  label="installment"
                />

               <!--  <vs-button
                  class="mt-2"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-plus"
                  >Add</vs-button
                > -->
              </td>
            </tr>
            <tr>
              <td>
                <h5 class="mb-2">Total Price <span class="text-red"></span></h5>
              </td>
              <td>
                <vs-input v-if="settings_obj.course_type != 3 || settings_obj.course_type != 4" type="number" class="inputx" min="0" v-model="settings_obj.total_price" />
                <vs-input v-else type="number" class="inputx" min="1" v-model="settings_obj.total_price" />
              </td>
            </tr>
            <tr v-if="settings_obj.payment_option === '2'">
              <td>
                <h5 class="mb-2">
                  Installment Price <span class="text-red"></span>
                </h5>
              </td>
              <td>
                <vs-input
                  class="inputx"
                  v-model="settings_obj.installment_price"
                />
              </td>
            </tr>
                        <tr v-if="settings_obj.payment_option === '2'">
              <td>
                <h5 class="mb-2">Installment Schedule</h5>
              </td>
              <td>
                <flat-pickr
                  placeholder="Select Date"
                  v-model="settings_obj.installment_start_date"
                ></flat-pickr>
              </td>
            </tr>
          </table>
        </div>
      </vs-tab>

      <!-- enrollment settings -->
      <vs-tab label="Enrollment">
        <div class="tab-text">
          <!--  -->
          <table class="course-table w-full p-4 border-top">
            <tr>
              <td>
                <h5 class="mb-2">
                  Enrollment Deadline <span class="text-red"></span>
                </h5>
                <p>
                  If enabled then a period must be specified prior to the start of the course. (e.g x number of days/weeks/months before the start of the course ) after which the course will no longer be available for new enrollments.
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="enrollment_rule"
                    v-model="settings_obj.enrollment_rule"
                    vs-value="1"
                    >Student can enrol at any time</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="enrollment_rule"
                    v-model="settings_obj.enrollment_rule"
                    vs-value="2"
                    >Student can't enrol after the start date</vs-radio
                  >
                </div>
              </td>
            </tr>
            <!-- <tr>
              <td>
                <h5 class="mb-2">
                  Signup Approval <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="signup_approval"
                    v-model="settings_obj.signup_approval"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="signup_approval"
                    v-model="settings_obj.signup_approval"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
            <!-- <tr>
              <td>
                <h5 class="mb-2">
                  Prerequisites <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio v-model="settings_obj.prerequisites" vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio v-model="settings_obj.prerequisites" vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
            <!-- <tr>
              <td>
                <h5 class="mb-2">
                  Downgrade Allowed <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="downgrade_allowed"
                    v-model="settings_obj.downgrade_allowed"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="downgrade_allowed"
                    v-model="settings_obj.downgrade_allowed"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
          </table>
        </div>
      </vs-tab>

      <!-- content settings -->
      <vs-tab label="Content">
        <div class="tab-text">
          
          <table class="course-table w-full p-4 border-top">
            <tr>
              <td>
                <h5 class="mb-2">
                  Structured content <span class="text-red"></span>
                </h5>
                <strong class="mb-2" style="color: rgba(var(--vs-primary), 1);">As the course creator, it’s up to you how you want to let your users navigate through your course. You have two options:</strong>
                <ul class="course_settings_listing">
                  <li>Free form (default)
                    <p>Allows the user to move freely through the course without following the course steps in any particular order. Ex: A user may take the tenth lesson before completing the first one.</p></li>
                    <li>Linear
                    <p>Requires the user to progress through course steps in the order in which you’ve laid them out. They cannot jump around and skip lessons, topics or quizzes. Ex: A user must finish the first lesson before they can take the second one.</p></li>
                </ul>
              </td>
              <td>
                
                <div class="my-2">
                  <vs-radio
                    vs-name="structured_content"
                    v-model="settings_obj.structured_content"
                    vs-value="free_form"
                    >Free Form</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="structured_content"
                    v-model="settings_obj.structured_content"
                    vs-value="linear"
                    >Linear</vs-radio
                  >
                </div>
                <!-- {{settings_obj.structured_content}} -->
              </td>
            </tr>
               <tr>
              <td>
                <h5 class="mb-2">
                  Content Visibility <span class="text-red"></span>
                </h5>
                <p>This course content setting determines who can see the list of lessons, topics & quizzes that make up your course. This does not affect the content that you add to the course page. That content will be displayed to everyone.</p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="content_visibility"
                    v-model="settings_obj.content_visibility"
                    :vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="content_visibility"
                    v-model="settings_obj.content_visibility"
                    :vs-value="0"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr>

            
           <!--  <tr>
              <td>
                <h5 class="mb-2">Lesson has Topics</h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="lesson_has_topic"
                    v-model="settings_obj.lesson_has_topic"
                    vs-value="1"
                    >Linear</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="lesson_has_topic"
                    v-model="settings_obj.lesson_has_topic"
                    vs-value="2"
                    >Free Form</vs-radio
                  >
                </div>
              </td>
            </tr> -->
          
            <!--  <tr>
              <td>
                <h5 class="mb-2">
                  Course has activities <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="course_has_activities"
                    v-model="settings_obj.course_has_activities"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="course_has_activities"
                    v-model="settings_obj.course_has_activities"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
            <!-- <tr>
              <td>
                <h5 class="mb-2">
                  Course Room and Equipment<span class="text-red"></span>
                </h5>
                <p>
                  Specify room and equipment which are required for the course
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="course_need_space"
                    v-model="settings_obj.course_need_space"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="course_need_space"
                    v-model="settings_obj.course_need_space"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
                <div v-if="settings_obj.course_need_space == '1'">
                  <vs-button @click="equipmentPop = true"
                    >Select Room</vs-button
                  >
                </div>
              </td>
            </tr> -->
            <!-- <tr>
              <td>
                <h5 class="mb-2">Make course invisible to students</h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="course_invisible_to_student"
                    v-model="settings_obj.course_invisible_to_student"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="course_invisible_to_student"
                    v-model="settings_obj.course_invisible_to_student"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
            <!--     <tr>
              <td>
                <h5 class="mb-2">
                  Course has homework <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="lesson_has_homework"
                    v-model="settings_obj.lesson_has_homework"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="lesson_has_homework"
                    v-model="settings_obj.lesson_has_homework"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
          <!--   <tr>
              <td>
                <h5 class="mb-2">Make homework visible</h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="make_homework_visible"
                    v-model="settings_obj.make_homework_visible"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="make_homework_visible"
                    v-model="settings_obj.make_homework_visible"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
            <!--  <tr>
                            <td>
                                <h5 class="mb-2">Course has equipments <span class="text-red"></span></h5>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                            </td>
                            <td>
                                <div class="my-2"><vs-radio vs-name="course_has_equipments" v-model="settings_obj.course_has_equipments" vs-value="1">Yes</vs-radio></div>
                                <div class="my-2"><vs-radio vs-name="course_has_equipments" v-model="settings_obj.course_has_equipments" vs-value="2">No</vs-radio></div>
                                <div v-if="settings_obj.course_has_equipments == '1'"><vs-button>Select Equipement</vs-button></div>
                            </td>
                        </tr> -->
          </table>
        </div>
      </vs-tab>

      <!-- scheduling settings -->
      <vs-tab label="Scheduling">
        <div class="tab-text">
          
          <table class="course-table w-full p-4 border-top">
            <!-- {{hasSelfPaced}} -->
            <tr>
              <td>
                <h5 class="mb-2">Course Class type</h5>
                <strong class="mb-2" style="color: rgba(var(--vs-primary), 1);">Courses can be delivered as</strong>
                <ul class="course_settings_listing">
                  <li>Self Paced Course: These type of courses require no teacher intervention. All course materials are online, and the students can take the course flexibly whenever it suits them. No scheduling required.</li>
                  <li>Online Individual Course: These are one to one online courses and cater for the individual requirements of each student. Usually these are run over Zoom or Skype. Scheduling for teachers and students will be required. </li>
                  <li>Online Group Course: These are group online courses. A maximum class size must be specified for all group courses.</li>
                </ul>
                <i style="color: rgba(var(--vs-primary), 1);">Typically rooms will not be booked for online courses unless required.</i>
                <ul class="course_settings_listing">
                  <li>In-Person Individual Course: These are one to one courses that typically occur in a specific location (school, home, or other locations) and cater for the individual requirements of each student. Scheduling for teachers, students and classrooms will be required. </li>
                  <li>In-Person Group Course: similar to the In-Person Individual Courses but caters for a group of students taking the same course. </li>
                </ul>
              </td>
              <td>
         <!-- disabled removed because amar's dabi -->
                <v-select
                  class="w-full"
                  v-model="settings_obj.course_class_type"
                  :options="course_class_type_list"
                  label="name"
                  :reduce="(item) => item.value"
                  placeholder="Select Class Type"
                />
              </td>
            </tr>
            <!-- <tr v-if="one2ManyType">
              <td>
                <h5 class="mb-2">Course Time Line</h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen books.
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="course timeline"
                    v-model="settings_obj.course_timeline"
                    vs-value="specific"
                    >Specific</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="course timeline"
                    v-model="settings_obj.course_timeline"
                    vs-value="not_specific"
                    >Not Specific</vs-radio
                  >
                </div>

              </td>
            </tr> -->
            <!-- {{one2ManyType}} -->
            <!-- {{one2ManyType}} -->
            <tr v-if="!one2ManyType && !hasSelfPaced">
              <td>
                <h5 class="mb-2">
                  Session Frequency<span
                    class="text-red"
                  ></span>
                </h5>
              </td>
              <td>
                <div class="my-2">
                   <vs-radio
                   :disabled="this.$route.params.editing_object?true:false"
                    vs-name="session_frequency"
                    v-model="settings_obj.session_frequency"
                    vs-value="0"
                    >One Time</vs-radio
                  >
                  <vs-radio
                  :disabled="this.$route.params.editing_object?true:false"
                    vs-name="session_frequency"
                    v-model="settings_obj.session_frequency"
                    vs-value="1"
                    >Daily</vs-radio
                  >
                  <div
                    class="flex items-center my-2"
                    v-if="settings_obj.session_frequency == '1'"
                  >
                    <div class="w-2/3">
                      <vs-input
                        class="w-full"
                        v-model="settings_obj.class_duration"
                        type="number"
                        min="0"
                        placeholder="Eg 2 Days"
                      />
                    </div>
                    <strong class="ml-2">Days</strong>
                  </div>
                </div>
                <div class="my-2">
                  <vs-radio
                  :disabled="this.$route.params.editing_object?true:false"
                    vs-name="session_frequency"
                    v-model="settings_obj.session_frequency"
                    vs-value="2"
                    >Weekly</vs-radio
                  >

                  <!-- {{settings_obj.session_frequency}} -->
                  <!-- {{weekOption}} -->
                  <!--   <v-select
                    multiple
                    v-if="settings_obj.session_frequency == '2'"
                    :options="weekOption"
                    v-model="settings_obj.session_frequency_week_day"
                    v-validate="'required'"
                  >
                  </v-select> -->
                  <vs-input
                    v-if="
                      settings_obj.session_frequency == '2' &&
                      hasOne2OneChecking
                    "
                    type="number"
                    min="0"
                    :disabled="this.$route.params.editing_object?true:false"
                    v-model="settings_obj.max_days_in_week_or_month"
                    placeholder="Enter no. of times in week"
                  />
                  <div
                    class="flex items-center my-2"
                    v-if="settings_obj.session_frequency == '2'"
                  >
                    <div class="w-2/3">
                      <vs-input
                        class="w-full"
                        :disabled="this.$route.params.editing_object?true:false"
                        v-model="settings_obj.class_duration"
                        type="number"
                        min="0"
                        placeholder="Eg 2 Weeks"
                      />
                    </div>
                    <strong class="ml-2">Weeks</strong>
                  </div>
                </div>
                <!-- {{checkingClassType}} -->
                <!-- {{settings_obj.class_duration}} -->
                <!-- <div class="my-2">
                  <vs-radio
                    vs-name="session_frequency"
                    v-model="settings_obj.session_frequency"
                    vs-value="3"
                    >Biweekly</vs-radio
                  >
                </div> -->
                <div class="my-2">
                  <vs-radio
                  :disabled="this.$route.params.editing_object?true:false"
                    vs-name="session_frequency"
                    v-model="settings_obj.session_frequency"
                    vs-value="4"
                    >Monthly</vs-radio
                  >
                  <vs-input
                    v-if="
                      settings_obj.session_frequency == '4' &&
                      hasOne2OneChecking
                    "
                    :disabled="this.$route.params.editing_object?true:false"
                    type="number"
                    min="0"
                    v-model="settings_obj.max_days_in_week_or_month"
                    placeholder="Enter no. of times in month"
                  />
                  <!-- {{monthDay}} -->
                  <!-- {{settings_obj.session_frequency_month_day}} -->
                  <!--  <v-select
                    multiple
                    v-if="settings_obj.session_frequency == '4' && hasOne2OneChecking"
                    :options="monthDay"
                    v-model="settings_obj.session_frequency_month_day"
                    v-validate="'required'"
                  >
                  </v-select> -->
                  <div
                    class="flex items-center my-2"
                    v-if="settings_obj.session_frequency == '4'"
                  >
                    <div class="w-2/3">
                      <vs-input
                        class="w-full"
                        :disabled="this.$route.params.editing_object?true:false"
                        v-model="settings_obj.class_duration"
                        type="number"
                        min="0"
                      />
                    </div>
                    <strong class="ml-2">Months</strong>
                  </div>
                </div>
                <!--  <div class="my-2">
                  <vs-radio
                    vs-name="session_frequency"
                    v-model="settings_obj.session_frequency"
                    vs-value="5"
                    >Quaterly</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="session_frequency"
                    v-model="settings_obj.session_frequency"
                    vs-value="6"
                    >Termly</vs-radio
                  >
                </div> -->
              </td>
            </tr>

               <tr v-if="!hasSelfPaced">
              <td>
                <h5 class="mb-2">
                  Minimum time requirement prior to booking <span class="text-red"></span>
                </h5>
                <p>
                  Set how late Courses can be booked (for example, require students to book at least 1 hour before the appointment time).
                </p>
              </td>
              <td>
                <div class="flex items-center my-2">
                  <div class="w-2/3">
                    <vs-input
                      v-model="settings_obj.minimum_time_requirement_prior_to_booking"
                      class="w-full"
                      onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"
                    />
                  </div>
                  <strong class="ml-2">Minutes</strong>
                </div>
              </td>
            </tr>

            <tr
             v-if="!hasSelfPaced"
            >
              <td>
                <h5 class="mb-2">
                  Session Duration <span class="text-red"></span>
                </h5>
                <p>
                  Select a time interval which will be used as a step when building all time slots in the system.
                </p>
              </td>
              <td>
                <div class="flex items-center my-2">
                  <div class="w-2/3">
                    <vs-input
                      v-model="settings_obj.session_duration"
                      placeholder="minutes"
                      class="w-full"
                      onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"
                    />
                  </div>
                  <strong class="ml-2">Minutes</strong>
                </div>
              </td>
            </tr>

            <!-- <tr
             v-if="!hasSelfPaced"
            >
              <td>
                <h5 class="mb-2">
                  Perpetual course <span class="text-red"></span>
                </h5>
                <small class="block mb-4"
                  >(automatic renewals, no lesson setup)</small
                >
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <vs-checkbox
                  class="my-2"
                  v-model="settings_obj.automatic_renewal"
                  >Automatic renewals</vs-checkbox
                >
                <vs-checkbox class="my-2" v-model="settings_obj.lesson_setup"
                  >No lesson setup</vs-checkbox
                >
              </td>
            </tr> -->
            <tr
             v-if="!hasSelfPaced"
            >
              <td>
                <h5 class="mb-2">
                  Number of Sessions <span class="text-red"></span>
                </h5>
                <p>
                  Select the number of sessions or leave blank if the number of session is unknown.
                </p>
              </td>
              <td>
                <vs-input
                  class="w-full"
                  placeholder="Enter session number"
                  v-model="settings_obj.no_of_sessions"
                  :disabled="true"
                />
              </td>
            </tr>

            <tr
             v-if="!hasSelfPaced"
            >
              <td>
                <h5 class="mb-2">
                  Reschedule allowed <span class="text-red"></span>
                </h5>
                <p>
                  Yes or No. If Yes select the maximum number of reschedule allowed (option to have infinite number of reschedule) 
                </p>
              </td>
              <td>
                <div class="my-2 flex flex-wrap">
                  <vs-radio
                    vs-name="reschedule_allowed"
                    v-model="settings_obj.reschedule_allowed"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                 
  <span class="inline-flex mx-2" v-if="settings_obj.reschedule_allowed == '1'"><vs-input-number v-model="settings_obj.reschedule_count" min="0"/></span> 
                </div>
               
                <div class="my-2">
                  <vs-radio
                    vs-name="reschedule_allowed"
                    v-model="settings_obj.reschedule_allowed"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr>
            <!-- <tr
             v-if="!hasSelfPaced && settings_obj.reschedule_allowed == '1'"
            >
              <td>
                <h5 class="mb-2">
                  Reschedule allowed <span class="text-red"></span>
                </h5>
                <p>
                  Yes or No. If Yes select the maximum number of reschdules allowed (option to have infinite number of reschdules) 
                </p>
              </td>
              <td>
               
                  <vs-input-number v-model="settings_obj.reschedule_count" min="0"/>

              </td>
            </tr> -->
            <!-- <tr
             v-if="!hasSelfPaced"
            >
              <td>
                <h5 class="mb-2">
                  Session During School Holiday <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="session_during_school_holiday"
                    v-model="settings_obj.session_during_school_holiday"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="session_during_school_holiday"
                    v-model="settings_obj.session_during_school_holiday"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
            <!--  <tr>
              <td>
                <h5 class="mb-2">Class Size <span class="text-red"></span></h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="class_size"
                    v-model="settings_obj.class_size"
                    vs-value="1"
                    >Individual</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="class_size"
                    v-model="settings_obj.class_size"
                    vs-value="2"
                    >Many</vs-radio
                  >
                </div>
              </td>
            </tr> -->
            <!-- <tr>
                            <td>
                                <h5 class="mb-2">Session Frequency <span class="text-red"></span></h5>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                            </td>
                            <td>
                                <vs-input-number v-model="settings_obj.session_frequency_hour" />
                            </td>
                        </tr> -->
            <!-- <div> -->
            <!-- <tr v-if="one2ManyType && !hasSelfPaced">
              <td>
                <h5 class="mb-2">
                  Application deadline <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <flat-pickr
                  v-model="settings_obj.application_deadline"
                ></flat-pickr>
              </td>
            </tr> -->
            <tr v-if="one2ManyType && !hasSelfPaced  ">
              <td>
                <h5 class="mb-2">
                  Course Start Date <span class="text-red"></span>
                </h5>
                <p>
                  Select a date from the calendar (default to TODAY’s date)
                </p>
              </td>
              <td>
                <!-- {{settings_obj.course_start_date}} -->
                <flat-pickr
                  @input="changeConfig"
                  placeholder="Select Date"
                  v-model="settings_obj.course_start_date"
                  :config="configDate" 
                ></flat-pickr>
              </td>
            </tr>
            <tr v-if="one2ManyType && !hasSelfPaced">
              <td>
                <h5 class="mb-2">
                  Course End Date <span class="text-red"></span>
                </h5>
                <p>
                  Select a date from the calendar 
                </p>
              </td>
              <td>
                <flat-pickr
                  placeholder="Select Date"
                  @on-open="changeConfig"
                  :config="configEndDate"
                  v-model="settings_obj.course_end_date"
                ></flat-pickr>
              </td>
            </tr>
            <!-- <tr v-if="one2ManyType && !hasSelfPaced">
              <td>
                <h5 class="mb-2">
                  Course Join End Date <span class="text-red"></span>
                </h5>
              </td>
              <td>
                <flat-pickr v-model="settings_obj.join_end_date"></flat-pickr>
              </td>
            </tr> -->

            <tr v-if="one2ManyType && !hasSelfPaced">
              <td>
                <h5 class="mb-2">
                  Course Start Timing <span class="text-red"></span>
                </h5>
                <router-link to="settings?tab=4">School Schedule</router-link>
                <!-- <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p> -->
              </td>
              <td>
                <flat-pickr
                  v-model="settings_obj.course_start_time"
                  :config="configStartTiming"
                  @change="configEnd()"
                  @on-close="changeConfigTiming"
                ></flat-pickr>
              </td>
            </tr>
            <!-- {{checkingClassType}} -->
            <tr v-if="one2ManyType && !hasSelfPaced">
              <td>
                <h5 class="mb-2">
                  Course End Timing<span class="text-red"></span>
                </h5>
                <router-link to="settings?tab=4">School Schedule</router-link>
              <!--   <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p> -->
              </td>
              <td>
                <flat-pickr
                  v-model="settings_obj.course_end_time"
                  :config="configEndTiming"
                  @on-open="changeConfigTiming"
                ></flat-pickr>
              </td>
            </tr>
            <!-- </div> -->

            <tr v-if="!hasSelfPaced">
              <td>
                <h5 class="mb-2">Course Location</h5>
                <p>
                  Courses can be delivered Online, at School, at Home, or Other Location. Select the appropriate option for the course.
                </p>
              </td>
              <td>
                <v-select
                  append-to-body
                  class="w-full"
                  v-model="settings_obj.course_class_place"
                  :options="coursePLaceType"
                  :reduce="(option) => option.id"
                  label="place_name"
                />
              </td>
            </tr>

            <tr v-if="settings_obj.course_class_type == 'online_one_2_many' || settings_obj.course_class_type == 'offline_one_2_many'">
              <td>
                <h5 class="mb-2">
                  Course Room and Inventory<span class="text-red"></span>
                </h5>
                <p>
                  Specify room and inventory which are required for the course
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="course_need_space"
                    v-model="settings_obj.course_need_space"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="course_need_space"
                    v-model="settings_obj.course_need_space"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
                <div v-if="settings_obj.course_need_space == '1'">
                  <vs-button @click="equipmentPop = true"
                    >Select Rooms & Inventories</vs-button
                  >
                </div>
              </td>
            </tr>

            <!--   {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true -->
          </table>
        </div>
      </vs-tab>

      <!-- assesment settings -->

      <vs-tab label="Certificate">
        <div class="tab-text">
          <!-- {{settings_obj}} -->
              <table class="course-table course_type_table w-full p-4 border-top">
            <tr>
              <td>
                <b>Template</b>
              </td>
              <td>
               
                   <vs-button color="primary" type="filled" @click="template_list=true">Certificate Settings</vs-button>
                
              </td>
            </tr>
             <tr>
              <td>
                <b>Share Options</b>
              </td>
              <td>
                  <vs-radio  v-model="settings_obj.certificate_share_type" vs-name="certificate_share_type" vs-value="1">Manual Share</vs-radio>&nbsp;&nbsp;
    <vs-radio v-model="settings_obj.certificate_share_type" vs-name="certificate_share_type" vs-value="2">Share after course end date</vs-radio>
              </td>
            </tr>
              </table>
           
        
          <table class="course-table w-full p-4 border-top">
            <!-- <tr>
              <td>
                <h5 class="mb-2">
                  Exam/Assessment <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="has_exam"
                    v-model="settings_obj.has_exam"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="has_exam"
                    v-model="settings_obj.has_exam"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
            <!-- <tr>
              <td>
                <h5 class="mb-2">
                  Completion Certificate <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="completion_certificate"
                    v-model="settings_obj.completion_certificate"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="completion_certificate"
                    v-model="settings_obj.completion_certificate"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
            <!-- <tr>
              <td>
                <h5 class="mb-2">
                  Progress Report <span class="text-red"></span>
                </h5>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </p>
              </td>
              <td>
                <div class="my-2">
                  <vs-radio
                    vs-name="progress_report"
                    v-model="settings_obj.progress_report"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </div>
                <div class="my-2">
                  <vs-radio
                    vs-name="progress_report"
                    v-model="settings_obj.progress_report"
                    vs-value="2"
                    >No</vs-radio
                  >
                </div>
              </td>
            </tr> -->
          </table>
        </div>
      </vs-tab>
      <vs-tab label="Communication">
          <div class="tab-text">
          
          <table class="course-table w-full p-4 border-top">
           <tr>
              <td>
                <b>Chat With Participant</b>
              </td>
              <td>
                <p>
                  <vs-checkbox
                    v-model="settings_obj.can_chat_with_participants"
                  >
                    Chat With Participant
                  </vs-checkbox>
                </p>
              </td>
            </tr>
          </table>
        </div>

    </vs-tab>
    </vs-tabs>
    
<vs-popup title="Template List" :active.sync="template_list">
      <!-- <certificateBuiler /> -->
    
            <vs-table class="cstm_vuexy_table" :data="courseTempList">
            <template slot="thead">
              <vs-th></vs-th>
                <vs-th style="width: 240px;"> Certificate Name </vs-th>
                <vs-th style="width: 325px;"> Certificate Description </vs-th>
                <vs-th style="width: 325px;">Preview </vs-th>
            </template>
            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr]">
                     <vs-checkbox  :checked="settings_obj.certificate_template_id==data[indextr].certificate_template_id" @change="handleChange(data[indextr].certificate_template_id)" ></vs-checkbox>
                  </vs-td>
                <vs-td :data="data[indextr].title">
                    {{ data[indextr].title }}
                </vs-td>
                <vs-td :data="data[indextr].description">
                    {{ data[indextr].description }}
                </vs-td>
                <vs-td>
                    <div class="flex">
                      <vs-button class="mx-1" icon-pack="feather" @click="preview(data[indextr])" 
                        icon="icon-eye"
                        type="filled"></vs-button>
                      
                    </div>
                </vs-td>
                </vs-tr>
            </template>
            </vs-table>
            <vs-card v-if="previewModal">
              <previewTemp :tempDetail="tempDetails"> </previewTemp>
              </vs-card> 
      <vs-button color="primary" @click="template_list=false" type="filled">Save</vs-button>
</vs-popup>
    <vs-popup title="Add Rooms & Inventories " :active.sync="equipmentPop">
      <equipment-component
        :assets="assets"
        @getAssetsValue="getAssetsValue"
      ></equipment-component>
    </vs-popup>

    <!-- <settings-component></settings-component> -->
  </div>
</template>

<script>
import previewTemp from '../../Testing/previewTemplate.vue'
import certificateBuiler from '../../Testing/tinyMce.vue'
import {getCurrentList} from '@/api/generalapi.js'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {fetchcourseTem} from '@/api/certificate'
import { SettingsMixin } from '../mixins/SettingsMixin'

import EquipmentComponent from './Common/EquipmentComponent.vue'
// import EquipmentComponent from

export default {
  data () {
    return {
      previewModal:false,
      tempDetails:'',
      template_id:null,
      template_list:false,
      courseTempList:[],
      currency_id:JSON.parse(localStorage.getItem('localization')).currency_id,
      date_format:'',
      configDate:{
        altInput: true,
        altFormat: 'j F, Y',
        minDate: 'today',
        dateFormat: 'Y-m-d'
      },
      configEndDate:{
        altInput: true,
        altFormat: 'j F, Y',
        minDate: 'today',
        dateFormat: 'Y-m-d'
      },
      configStartTiming: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        dateFormat: 'H:i:S',
        time_24hr: true
      },
      configEndTiming: {
        enableTime: true,
        enableSeconds: true,
        minTime: '',
        noCalendar: true,
        dateFormat: 'H:i:S',
        time_24hr: true
      },
      equipmentPop: false,
      installments: [
        {
          id: 1,
          installment: '3 Months'
        },
        {
          id: 2,
          installment: '4 Months'
        }
      ],
      currencyLists:[]
    }
  },
  watch: {
    settings_obj: {
      handler (newVal, oldVal) {

        if (this.settings_obj.session_frequency == 0) {
          this.settings_obj.class_duration = 1
        }
        
        
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  components: {
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    EquipmentComponent,
    certificateBuiler,
    previewTemp
  },
  mixins: [SettingsMixin],
  props: {
    settings_object: {},
    course_id: {},
    assets: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    changeConfig () {
      this.configEndDate.minDate = this.settings_obj.course_start_date
      this.settings_obj.course_end_date = this.settings_obj.course_start_date
    },
    changeConfigTiming () {
      this.configEndTiming.minTime = this.settings_obj.course_start_time
    },
    handleChange (data) {
    
      this.settings_obj.certificate_template_id = data
      
      console.log(data)
    },
    preview (data) {
      this.previewModal = true
      this.tempDetails = data
    },
    async fetchTemplateList () {
      try {
        const responseCurrency = await fetchcourseTem(this.$store.getters.customerId)
        this.courseTempList = responseCurrency.data.data.certificate_template_list
        
        // 
                
      } catch (error) {
        
      }
    },
    async fetchCurrencyList () {
      try {
        const responseCurrency = await getCurrentList()
        this.currencyLists = responseCurrency.data.data.currency_list
        
        // 
                
      } catch (error) {
        
      }
    },
    getAssetsValue (payload) {
      
      
      this.equipmentPop = false
      this.$emit('getAssetsValue', payload)
    }
  },
  mounted () {
    // this.$emit('input', this.settings_obj)
    // 
    //this.date_format = localStorage.getItem('date_format')
    this.settings_obj = this.settings_object
    this.fetchCurrencyList()
    this.fetchTemplateList()
  }
}
</script>
<style>
.course-table > tr td {
  min-width: 500px;
  max-width: 500px;
}
.course_type_table > tr td:first-child {
  min-width: auto;
  width: auto;
  max-width: 500px;
}
.course_type_table > tr td {
  min-width: auto;
  width: auto;
  max-width: 500px;
}
.course_settings_listing {
  margin-left: 15px;
}
.course_settings_listing li{
  position: relative;
  margin: 5px 0;
}
.course_settings_listing li::before {
  content: '\2023';
  font-size: 30px;
  height: 100%;
  position: absolute;
  top: -12px;
  left: -15px;
  color: rgba(var(--vs-primary), 1);
}
.course_vs_tabs .tab-text {
  overflow: auto;
}
</style>